import { ModuleParamGlobConfigService } from '../../../core/service/moduleFieldConfig/module-param-glob-config.service';

export class PartyWiseSalesLedgerParamConfigModel {
  constructor(private moduleParamConfigGlob: ModuleParamGlobConfigService) {}

  paramData = {
    startDate: {
      label: this.moduleParamConfigGlob.getLabel('PartyWiseSalesLedger', 'startDate', 'Start Date'),
      isVisible: this.moduleParamConfigGlob.isVisible('PartyWiseSalesLedger', 'startDate'),
      isRequired: this.moduleParamConfigGlob.isRequired('PartyWiseSalesLedger', 'startDate'),
    },
    endDate: {
      label: this.moduleParamConfigGlob.getLabel('PartyWiseSalesLedger', 'endDate', 'End Date'),
      isVisible: this.moduleParamConfigGlob.isVisible('PartyWiseSalesLedger', 'endDate'),
      isRequired: this.moduleParamConfigGlob.isRequired('PartyWiseSalesLedger', 'endDate'),
    },
    salesHead: {
      label: this.moduleParamConfigGlob.getLabel('PartyWiseSalesLedger', 'salesHead', 'Sales Head'),
      isVisible: this.moduleParamConfigGlob.isVisible('PartyWiseSalesLedger', 'salesHead'),
      isRequired: this.moduleParamConfigGlob.isRequired('PartyWiseSalesLedger', 'salesHead'),
    },
    status: {
      label: this.moduleParamConfigGlob.getLabel('PartyWiseSalesLedger', 'status', 'Status'),
      isVisible: this.moduleParamConfigGlob.isVisible('PartyWiseSalesLedger', 'status'),
      isRequired: this.moduleParamConfigGlob.isRequired('PartyWiseSalesLedger', 'status'),
    },
  };
  responseProduData = {
    orderNo: {
      label: this.moduleParamConfigGlob.getLabel(
        'SoCustomerLedgerResponseProductionDetails',
        'orderNo',
        'Order Number'
      ),
      isVisible: this.moduleParamConfigGlob.isVisible('SoCustomerLedgerResponseProductionDetails', 'orderNo'),
      isRequired: this.moduleParamConfigGlob.isRequired('SoCustomerLedgerResponseProductionDetails', 'orderNo'),
    },
    date: {
      label: this.moduleParamConfigGlob.getLabel('SoCustomerLedgerResponseProductionDetails', 'date', 'Order Date'),
      isVisible: this.moduleParamConfigGlob.isVisible('SoCustomerLedgerResponseProductionDetails', 'date'),
      isRequired: this.moduleParamConfigGlob.isRequired('SoCustomerLedgerResponseProductionDetails', 'date'),
    },
    expectedDate: {
      label: this.moduleParamConfigGlob.getLabel(
        'SoCustomerLedgerResponseProductionDetails',
        'expectedDate',
        'Delivery Expected Date'
      ),
      isVisible: this.moduleParamConfigGlob.isVisible('SoCustomerLedgerResponseProductionDetails', 'expectedDate'),
      isRequired: this.moduleParamConfigGlob.isRequired('SoCustomerLedgerResponseProductionDetails', 'expectedDate'),
    },
    qty: {
      label: this.moduleParamConfigGlob.getLabel('SoCustomerLedgerResponseProductionDetails', 'qty', 'Order Quantity'),
      isVisible: this.moduleParamConfigGlob.isVisible('SoCustomerLedgerResponseProductionDetails', 'qty'),
      isRequired: this.moduleParamConfigGlob.isRequired('SoCustomerLedgerResponseProductionDetails', 'qty'),
    },
    stock: {
      label: this.moduleParamConfigGlob.getLabel(
        'SoCustomerLedgerResponseProductionDetails',
        'stock',
        'Available Stock'
      ),
      isVisible: this.moduleParamConfigGlob.isVisible('SoCustomerLedgerResponseProductionDetails', 'stock'),
      isRequired: this.moduleParamConfigGlob.isRequired('SoCustomerLedgerResponseProductionDetails', 'stock'),
    },
    prodAgainstOrder: {
      label: this.moduleParamConfigGlob.getLabel(
        'SoCustomerLedgerResponseProductionDetails',
        'prodAgainstOrder',
        'Production Against Order'
      ),
      isVisible: this.moduleParamConfigGlob.isVisible('SoCustomerLedgerResponseProductionDetails', 'prodAgainstOrder'),
      isRequired: this.moduleParamConfigGlob.isRequired(
        'SoCustomerLedgerResponseProductionDetails',
        'prodAgainstOrder'
      ),
    },
    pendingProd: {
      label: this.moduleParamConfigGlob.getLabel(
        'SoCustomerLedgerResponseProductionDetails',
        'pendingProd',
        'Pending/Over Production'
      ),
      isVisible: this.moduleParamConfigGlob.isVisible('SoCustomerLedgerResponseProductionDetails', 'pendingProd'),
      isRequired: this.moduleParamConfigGlob.isRequired('SoCustomerLedgerResponseProductionDetails', 'pendingProd'),
    },
    dispatchAgainstOrder: {
      label: this.moduleParamConfigGlob.getLabel(
        'SoCustomerLedgerResponseProductionDetails',
        'dispatchAgainstOrder',
        'Dispatch Against Order'
      ),
      isVisible: this.moduleParamConfigGlob.isVisible(
        'SoCustomerLedgerResponseProductionDetails',
        'dispatchAgainstOrder'
      ),
      isRequired: this.moduleParamConfigGlob.isRequired(
        'SoCustomerLedgerResponseProductionDetails',
        'dispatchAgainstOrder'
      ),
    },
    pendingDispatch: {
      label: this.moduleParamConfigGlob.getLabel(
        'SoCustomerLedgerResponseProductionDetails',
        'pendingDispatch',
        'Pending/Over Dispatch'
      ),
      isVisible: this.moduleParamConfigGlob.isVisible('SoCustomerLedgerResponseProductionDetails', 'pendingDispatch'),
      isRequired: this.moduleParamConfigGlob.isRequired('SoCustomerLedgerResponseProductionDetails', 'pendingDispatch'),
    },
    materialName: {
      label: this.moduleParamConfigGlob.getLabel(
        'SoCustomerLedgerResponseProductionDetails',
        'materialName',
        'Material Name'
      ),
      isVisible: this.moduleParamConfigGlob.isVisible('SoCustomerLedgerResponseProductionDetails', 'materialName'),
      isRequired: this.moduleParamConfigGlob.isRequired('SoCustomerLedgerResponseProductionDetails', 'materialName'),
    },
    labelName: {
      label: this.moduleParamConfigGlob.getLabel(
        'SoCustomerLedgerResponseProductionDetails',
        'labelName',
        'Label Name'
      ),
      isVisible: this.moduleParamConfigGlob.isVisible('SoCustomerLedgerResponseProductionDetails', 'labelName'),
      isRequired: this.moduleParamConfigGlob.isRequired('SoCustomerLedgerResponseProductionDetails', 'labelName'),
    },
  };

  SoCustomerLedgerResponseDispatchDetail = {
    subtitle: {
      label: this.moduleParamConfigGlob.getLabel(
        'SoCustomerLedgerResponseDispatchDetails',
        'subtitle',
        'Dispatch Details'
      ),
    },
    invoiceNo: {
      label: this.moduleParamConfigGlob.getLabel(
        'SoCustomerLedgerResponseDispatchDetails',
        'invoiceNo',
        'Delivery Reference Number'
      ),
      isVisible: this.moduleParamConfigGlob.isVisible('SoCustomerLedgerResponseDispatchDetails', 'invoiceNo'),
      isRequired: this.moduleParamConfigGlob.isRequired('SoCustomerLedgerResponseDispatchDetails', 'invoiceNo'),
    },
    dispatchDate: {
      label: this.moduleParamConfigGlob.getLabel(
        'SoCustomerLedgerResponseDispatchDetails',
        'dispatchDate',
        'Dispatch Date'
      ),
      isVisible: this.moduleParamConfigGlob.isVisible('SoCustomerLedgerResponseDispatchDetails', 'dispatchDate'),
      isRequired: this.moduleParamConfigGlob.isRequired('SoCustomerLedgerResponseDispatchDetails', 'dispatchDate'),
    },
  };
  SoCustomerLedgerResponseProductionDetail = {
    subtitle: {
      label: this.moduleParamConfigGlob.getLabel(
        'SoCustomerLedgerResponseProductionDetails',
        'subtitle',
        'Production Details'
      ),
      isVisible: this.moduleParamConfigGlob.isVisible('SoCustomerLedgerResponseProductionDetails', 'subtitle'),
      isRequired: this.moduleParamConfigGlob.isRequired('SoCustomerLedgerResponseProductionDetails', 'subtitle'),
    },
    date: {
      label: this.moduleParamConfigGlob.getLabel(
        'SoCustomerLedgerResponseProductionDetails',
        'date',
        'Production Date'
      ),
      isVisible: this.moduleParamConfigGlob.isVisible('SoCustomerLedgerResponseProductionDetails', 'date'),
      isRequired: this.moduleParamConfigGlob.isRequired('SoCustomerLedgerResponseProductionDetails', 'date'),
    },
    machine: {
      label: this.moduleParamConfigGlob.getLabel('SoCustomerLedgerResponseProductionDetails', 'machine', 'Machine'),
      isVisible: this.moduleParamConfigGlob.isVisible('SoCustomerLedgerResponseProductionDetails', 'machine'),
      isRequired: this.moduleParamConfigGlob.isRequired('SoCustomerLedgerResponseProductionDetails', 'machine'),
    },
    shift: {
      label: this.moduleParamConfigGlob.getLabel('SoCustomerLedgerResponseProductionDetails', 'shift', 'Shift'),
      isVisible: this.moduleParamConfigGlob.isVisible('SoCustomerLedgerResponseProductionDetails', 'shift'),
      isRequired: this.moduleParamConfigGlob.isRequired('SoCustomerLedgerResponseProductionDetails', 'shift'),
    },
    shiftHours: {
      label: this.moduleParamConfigGlob.getLabel(
        'SoCustomerLedgerResponseProductionDetails',
        'shiftHours',
        'Shift Hours'
      ),
      isVisible: this.moduleParamConfigGlob.isVisible('SoCustomerLedgerResponseProductionDetails', 'shiftHours'),
      isRequired: this.moduleParamConfigGlob.isRequired('SoCustomerLedgerResponseProductionDetails', 'shiftHours'),
    },
  };
}
